export const host = 'https://syst-sign-api.danskebank.co.uk/api';
export const languageCode = 'en';
